import type { ContentPage } from "@/lib/content/types";

export const telephony: ContentPage = {
  slug: "omni-channels/telephony",
  template: "hrmsFeature",
  seo: {
    title: "CRM Telephony - Call, Log & Record from Your CRM | GetBiz CRM",
    description:
      "Make and receive calls inside GetBiz CRM with click-to-call, automatic logging, recording and call analytics — so every conversation is captured on the record.",
    keywords: [
      "CRM telephony",
      "click to call CRM",
      "call center CRM",
      "call logging software",
      "call recording CRM",
      "sales calling software",
    ],
    ogImage: "/assets/data/seoimages/telephony.webp",
  },
  leaf: {
    hero: {
      caption: "Telephony",
      title: "Call Customers Without Leaving Your CRM",
      description:
        "Click-to-call, auto-logging, recording and call analytics built into GetBiz CRM — so reps spend less time dialing and every call is captured against the contact.",
      h1: "caption",
    },
    split: {
      title: "Every Call, Captured Automatically",
      bullets: [
        { title: "Click-to-Call", description: "Dial any number in one click from the record." },
        { title: "Auto-logging", description: "Calls log against the contact automatically." },
        { title: "Recording", description: "Record and review calls for coaching and QA." },
        { title: "Call Analytics", description: "Track volume, duration and outcomes." },
      ],
      image: "/assets/images/img/product/crm/telephony-lead-image.webp",
      imageAlt: "GetBiz CRM telephony",
    },
    cardsHeading: { title: "More Omni Channels", description: "Telephony works with the rest of GetBiz CRM omni-channel." },
    cards: [
      { title: "Email", href: "/crm-software/omni-channels/email/", description: "Follow calls with tracked email.", image: "/assets/images/img/product/crm/email.webp", imageAlt: "CRM email" },
      { title: "SMS", href: "/crm-software/omni-channels/sms/", description: "Text a follow-up right after the call.", image: "/assets/images/img/product/crm/sms.webp", imageAlt: "CRM SMS" },
      { title: "WhatsApp", href: "/crm-software/omni-channels/whatsapp/", description: "Continue the conversation on WhatsApp.", image: "/assets/images/img/product/crm/whatsapp.webp", imageAlt: "CRM WhatsApp" },
      { title: "Social Media", href: "/crm-software/omni-channels/social-media/", description: "Handle social messages in the same inbox.", image: "/assets/images/img/product/crm/social-media.webp", imageAlt: "CRM social media" },
    ],
    testimonials: { title: "Calls that never go unlogged", description: "See why teams call from GetBiz CRM." },
    bookDemoTitle: "Add telephony to your CRM.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "crm-telephony-integration-guide, click-to-call-crm-benefits",
    metaKey: "telephony",
  },
  sections: [],
};
